import List from '@material-ui/core/List/List';
import * as React from 'react';
import { SearchListItem } from '../components/search-list-item';
import { SearchResultList } from '../components/search-result-list';
import { Iif } from './iif';

export interface ISearchPageProps<T> {
    searchPlaceholder: string;
    renderSearchResultItem: (item: T, index: number) => JSX.Element;
}

type SearchPageRendererProps<T> = ISearchPageRendererProps<T> & ISearchPageProps<T>;

export interface ISearchPageRendererProps<T> {
    /**
     * Request a search for the given term. This should set state and the results should come in items.
     */
    onSearch: (term: string) => void;
    query?: string;
    items?: T[];
    loading: boolean;
}

export class SearchPage<T> extends React.Component<SearchPageRendererProps<T>, any> {
    constructor(props: SearchPageRendererProps<T>) {
        super(props);
        this.state = {
            items: props.items,
            searchPlaceholder: props.searchPlaceholder,
            searchText: props.query
        };
    }
    public componentWillReceiveProps(nextProps: SearchPageRendererProps<T>) {
        this.setState({
            items: nextProps.items,
            searchPlaceholder: nextProps.searchPlaceholder,
            searchText: nextProps.query
        });
    }
    public componentDidMount() {
        this.performSearch(this.state.searchText);
    }
    private performSearch(term: string) {
        const { onSearch } = this.props;
        if (onSearch) {
            onSearch(term);
        }
    }
    private onSearch = (term: string) => {
        this.performSearch(term);
    }
    public render() {
        const { searchText, searchPlaceholder, items } = this.state;
        const { loading } = this.props;

        return <>
            <List>
                <SearchListItem value={searchText} searchPlaceholder={searchPlaceholder} onSearch={this.onSearch} />
            </List>
            <Iif loading={loading} show={!!items}>
                <SearchResultList items={items} rowRenderer={this.props.renderSearchResultItem} />
            </Iif>
        </>;
    }
}


// WEBPACK FOOTER //
// ./src/components/search-page.tsx